/** Shared height and padding for Live Canvas and runs toolbar rows. */
export const RUNS_SIDEBAR_ROW_CLASS =
  "flex h-9 min-w-0 shrink-0 items-center gap-1.5 border-b border-b-slate-950/10 px-3 dark:border-gray-800/70";

/** Taller fixed row used by the two-line runs list entries. */
export const RUNS_SIDEBAR_RUN_ROW_CLASS =
  "flex h-16 min-w-0 shrink-0 flex-col justify-center gap-1.5 border-b border-b-slate-950/10 px-3 py-2 dark:border-gray-800/70";
